import { Stack } from '@mui/material';
import InfiniteItems from '../InfiniteItems';
import useGetCrypto, { CryptoType } from '@/hooks/useGetCrypto';
import map from 'lodash/map';
import Info from '../../../public/json/shitcoin/info.json';
import InfiniteListItem from './InfiniteListItem';

const InfinitList = () => {
  const getMultipleRandom = (arr: any[], num: number) => {
    const shuffled = [...arr].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, num);
  };
  const symbolFilter = map(
    Info.list,
    item =>
      `${item.base.toString().toUpperCase()}${item.quote
        .toString()
        .toUpperCase()}`
  );
  const { shitcoinTablePrice } = useGetCrypto(
    {
      shitcoinTable: true
    },
    'getCurrentList',
    symbolFilter
  );

  return (
    <Stack mb={{ xs: 8.5, lg: 22.5 }} zIndex={2} position="relative">
      <InfiniteItems duration={200000}>
        {map(getMultipleRandom(shitcoinTablePrice || [], 10), (item, i) => (
          <InfiniteListItem key={i} crypto={item} />
        ))}
      </InfiniteItems>
      <InfiniteItems duration={100000}>
        {map(getMultipleRandom(shitcoinTablePrice || [], 10), (item, i) => (
          <InfiniteListItem key={i} crypto={item} />
        ))}
      </InfiniteItems>
    </Stack>
  );
};

export default InfinitList;
